<template>
  <div>
    <b-form @keyup.enter="query" onsubmit="return false">
      <el-col :span="24">
        <el-input class="input-with-select" placeholder="Search here..." v-model="form.searchKeyWord">
          <dict-select
              v-model="form.custCode"
              url="/digitalCenter/common/dict/customer"
              :placeholder="$l('project_table_label_customer')||'客户'"
              slot="prepend"
              filterable
              clearable
          ></dict-select>
          <el-button slot="append" icon="el-icon-search" @click="query"></el-button>
        </el-input>
      </el-col>
    </b-form>
  </div>
</template>

<script>

export default {
  data () {
    return {
      form: {
        searchKeyWord: '',
        custCode: ''
      }
    }
  },
  methods: {
    query () {
      this.$emit('submit', this.form)
    },
    reset () {
      this.form = {
        searchKeyWord: '',
        custCode: ''
      }
      this.$emit('reset')
      this.query()
    }
  }
  // created () {
  //   this.reset()
  // },
  // activated () {
  //   this.reset()
  // }
}
</script>

